import React from "react";
import View from "../ReactNative/View";
import AppTheme from "../../utils/Theme";
import Text from "../ReactNative/Text";
import { Platform, StyleSheet } from "react-native";
import Colors from "../../Theme/Colors";
import Fonts from "../../Theme/Fonts";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import User from "../../data/user/User";

interface SectionHeaderProps {
    number: number;
    title: string;
    forceWidth?: number;
}

const SectionHeader = (props: SectionHeaderProps) => {

    const appTheme: AppTheme = new AppTheme();
    const userState: User = User.getInstance();

    const {
            fullScreenWidth,
            fullScreenHeight,
            availableScreenSize,
            contentSize,
            sideMenuSize,
            horizontalSpacing
        } = useSpecificSize();

    const { number, title, forceWidth = contentSize - 2*horizontalSpacing } = props;

    const headerNumberViewSize: number = Platform.OS === "web" ? appTheme.pixelPerfect(80) : appTheme.pixelPerfect(60);
    const headerTitleViewSize: number = Platform.OS === "web" ? appTheme.pixelPerfect(60) : appTheme.pixelPerfect(40);
    const headerSize: number = (headerNumberViewSize/2) + headerTitleViewSize;

    return <View style={{ alignItems: "center", width: forceWidth, height: headerSize }}>
        <View style={{
            position: "absolute",
            width: headerNumberViewSize,
            height: headerNumberViewSize,
            borderRadius: headerNumberViewSize/2,
            backgroundColor: userState.profile === "family" ? Colors.parentLightBackgroundColor : Colors.institutionColor
        }}>
            <View style={{ height: headerNumberViewSize/2, justifyContent: "center" }}>
                <Text style={[style.text, { color: Colors.premiumColor, fontSize: appTheme.pixelPerfectForFont(13) }]}>{number}</Text>
            </View>
        </View>
        <View style={{ marginTop: headerNumberViewSize/2, justifyContent:"center", alignItems:"center", height: headerTitleViewSize, width: forceWidth, backgroundColor: userState.profile === "family" ? Colors.parentLightBackgroundColor : Colors.institutionColor, borderTopRightRadius: Platform.OS === "web" ? appTheme.pixelPerfect(28) : appTheme.pixelPerfect(14), borderTopLeftRadius: Platform.OS === "web" ? appTheme.pixelPerfect(28) : appTheme.pixelPerfect(14) }}>
            <Text style={[style.text, { fontSize: appTheme.pixelPerfectForFont(8), textTransform: "uppercase", paddingHorizontal: appTheme.pixelPerfect(4) }]}>{title}</Text>
        </View>
    </View>
}

export default SectionHeader;

const style = StyleSheet.create({
    text: {
        color: "#FFFFFF",
        textAlign: "center",
        fontFamily: Fonts.primary.bold
    }
});